import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/advanced/jobs/')({
    component: RouteComponent,
});

function RouteComponent() {
    return null;
}
